import React, { useCallback, useEffect, useState } from 'react';
import { getMyRoutesAccessService } from '../../../features/user/service/user-service';
import { fetchCompanyPlanStatus } from '../../../features/company/service/company';
import './style.css';
import ButtonPrimary from '../../../components/buttons/primary/primary';
import MenuTop from '../../../components/menu/top/menu-top';
import { askUpdatePlanUserService } from '../../../features/user/service/user-service';
import { useAlert } from '../../../components/alert/alert';
import { SEVERITY } from '../../../shared/interfaces/alert';
import { useNavigate } from 'react-router-dom';

export function ListUser() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const [companyPlanStatus, setCompanyPlanStatus] = useState<any>(null);
    const showAlert = useAlert();
    const navigate = useNavigate();

    const fetchCompanyStatus = useCallback(async () => {
        try {
            const response = await fetchCompanyPlanStatus(user?.company.id);
            setCompanyPlanStatus(response);
        } catch (error) {
            console.error('Erro ao buscar status do plano da empresa:', error);
        }
    }, [user.company.id]);
    
    const fetchRoutesAccess = useCallback(async () => {
        try {
            await getMyRoutesAccessService(user.id);
        } catch (error) {
            console.error('Erro ao buscar rotas de acesso:', error);
        }
    }, [user.id]);

    const handleUpgradePlan = async () => {
        try {
            await askUpdatePlanUserService(user.email);
            showAlert('Pedido de upgrade enviado com sucesso', SEVERITY.SUCCESS);
        } catch (error) {
            console.error('Erro ao atualizar plano:', error);
        }
    };

    const handleChangePassword = () => {
        navigate(`/primeiro-acesso/${user.email}`);
    }

    useEffect(() => {
        fetchRoutesAccess();
        fetchCompanyStatus();
    }, [fetchCompanyStatus, fetchRoutesAccess]);

    const renderPlanProgress = () => {
        if (!companyPlanStatus) return null;
        
        const usedPercentage = (companyPlanStatus.projectsUsed / companyPlanStatus.quantityProjects) * 100;

        return (
            <div className="plan-progress">
                <div className="plan-progress__header">
                    <span>Projetos do Plano</span>
                    <span>
                        {companyPlanStatus.projectsUsed}/{companyPlanStatus.quantityProjects}
                    </span>
                </div>
                <div className="plan-progress__bar">
                    <div 
                        className={`plan-progress__indicator ${
                            usedPercentage > 80 ? 'high-usage' : 
                            usedPercentage > 50 ? 'medium-usage' : 
                            'low-usage'
                        }`} 
                        style={{width: `${usedPercentage}%`}}
                    ></div>
                </div>

                {usedPercentage >= 80 &&
                    <div style={{ marginLeft: '-15px' }}>
                        <ButtonPrimary title="Upgrade de Plano" onClick={handleUpgradePlan} />
                    </div>
                }
            </div>
        );
    };

    return (
        <div className="container-user">
            <MenuTop />
            <div className="container-user__content">
                <div className="container-user__content__info">
                    <div className="container-user__content__info__image">
                        <img 
                            src={user?.image || 'https://placehold.co/100x100'} 
                            alt={`Foto de perfil de ${user.name}`} 
                        />
                    </div>
                    <div className="container-user__content__info__details">
                        <h2>{user.name}</h2>
                        <p>{user.email}</p>

                        <div style={{ marginLeft: '-15px' }}>
                            <ButtonPrimary title="Trocar Senha" onClick={handleChangePassword} />
                        </div>

                        <div className="company-info">
                            <h3>Informações da Empresa</h3>
                            <p><strong>Empresa:</strong> {user.company.name}</p>
                            
                            {companyPlanStatus && (
                                <div>
                                    <p><strong>Plano:</strong> {companyPlanStatus.name}</p>
                                    {renderPlanProgress()}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
